import { Component, inject, signal } from '@angular/core';
import { SessionService } from '../tenant/session.service';
import { VersionServidaService, textoDeLaVersion } from './version-servida.service';
import { NUMERO_DE_VERSION } from './numero-de-version';

/**
 * La versión, en pequeño y con «Copiar».
 *
 * Existe para una conversación concreta: cuando el comerciante llama diciendo «no me deja cobrar», lo primero es
 * saber **qué versión estaba viendo**. Pedirle que lea un SHA por teléfono no funciona; un botón que lo copia, sí.
 * No es un adorno: sin esto, cada reporte empieza adivinando.
 */
@Component({
  selector: 'app-version-servida',
  standalone: true,
  template: `
    <div class="ver" data-testid="version-servida">
      <span class="ver-numero" data-testid="numero-version">Versión {{ numero }}</span>
      <span class="ver-texto" data-testid="version-texto">{{ texto() }}</span>
      @if (version.version().corto) {
        <button type="button" class="ver-copiar" (click)="copiar()" data-testid="version-copiar"
          [attr.aria-label]="'Copiar ' + texto()">{{ copiado() ? 'Copiado' : 'Copiar' }}</button>
      }
    </div>
  `,
  styles: [`
    /* Se parte en dos líneas antes que recortarse: medido a 360 px, «Compilación ea505a4 · última conocida, del 16/09
       13:06» pide 290 px y en la barra caben 175, así que sin partirlo se comía la fecha —justo el dato que hace
       útil a la «última conocida»—. Dos líneas cortas en el pie no le quitan sitio a nadie. */
    .ver { display: flex; align-items: baseline; flex-wrap: wrap; gap: var(--esp-1, .25rem);
      font-size: var(--texto-xs, .75rem); color: var(--color-slate-500, #64748b); }
    .ver-numero { flex-basis: 100%; }
    .ver-texto { white-space: normal; overflow-wrap: anywhere; min-width: 0; }
    .ver-copiar { border: 0; background: transparent; color: inherit; font: inherit; text-decoration: underline;
      cursor: pointer; padding: var(--esp-1, .25rem); }
  `],
})
export class VersionServidaComponent {
  readonly version = inject(VersionServidaService);
  private readonly session = inject(SessionService);
  readonly copiado = signal(false);
  readonly numero = NUMERO_DE_VERSION;

  constructor() {
    void this.version.leer(this.session.session()?.userName ?? null);
  }

  texto(): string {
    return textoDeLaVersion(this.version.version());
  }

  /** Copia lo que se ve. Si el navegador no deja, no se miente: el botón se queda como estaba. */
  async copiar(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.texto());
      this.copiado.set(true);
      setTimeout(() => this.copiado.set(false), 2000);
    } catch {
      /* sin portapapeles (contexto no seguro, permiso denegado): el texto sigue a la vista para leerlo */
    }
  }
}
